import { createHash } from 'crypto';

const hashString = (stringToHash) => {
    const hash = createHash('sha256');
    hash.update(stringToHash);
    return hash.digest('hex');
}

const stripIsTranferKeys = (agreementGroups) =>
    JSON.stringify(agreementGroups, (key, val) => {
        if (key === 'isTransfer') {
            return undefined;
        }
        return val;
    });

export const stripIsTranferKeysAndHash = (agreementGroups) =>
    hashString(stripIsTranferKeys(agreementGroups));

export const getIsTranferSelections = (agreementGroups) => {
    const isTransferIndexes = [];
    agreementGroups.forEach((agreementGroup, groupIndex) => {
        agreementGroup.agreements.forEach((agreement, agreementIndex) => {
            if (agreement.isTransfer) {
                isTransferIndexes.push({groupIndex, agreementIndex});
            }
        })
    });
    return isTransferIndexes;
};

export const determineFundName = (agr) => {
    if (agr.productTypeId === 20) {
        return "Brokerage";
    }
    if (agr.productTypeId === 110) {
        return "Active Plus Portfolio";
    }
    return agr.holdings[0].fundName;
};

export const determineFundTicker = (agr) =>
    (agr.productTypeId === 20 || agr.productTypeId === 110) ? "" : `(${agr.holdings[0].ticker})`;

export const determineRegistrationGroupingDisplayName = (agrGroup) => {
    const { agreementTypeName, agreementTypeId, owners } = agrGroup;
    return `${agreementTypeName}${agreementTypeId === 26 && owners.length > 1 ? ' (Joint)' : ''}`
};
